<template>
  <Teleport to="body">
    <div v-if="visible" class="modal-overlay" @click.self="handleClose">
      <div class="modal-content">
        <div class="modal-header">
          <h3>{{ s__('ProjectSettings|Task Categories') }}</h3>
          <button type="button" class="modal-close" @click="handleClose" aria-label="Close">
            <CloseIcon />
          </button>
        </div>

        <div class="modal-body">
          <div class="info-section">
            <p>
              {{
                s__(
                  'ProjectSettings|Task categories allow you to classify tasks by type (e.g., Bug, Feature, Task). Each category can have its own workflow and optional grading scale, providing flexibility in how different types of work are managed.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|How It Works') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|When creating a task category, you can assign it a workflow that defines the statuses and transitions available for tasks of that type. If task grades are enabled, you can also assign a grading scale to track quality or completion level for finished tasks.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Workflow Assignment') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|Each task category can use a specific workflow, or you can set it to auto-select the default workflow. This allows different types of tasks to follow different processes while maintaining consistency within each type.'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Grading Scales') }}</h4>
            <p>
              {{
                s__(
                  'ProjectSettings|If task grades are enabled for the project, you can assign a grading scale to a task category. This allows you to grade finished tasks using a standardized scale (e.g., A+, A, B, C or 5, 4, 3, 2, 1).'
                )
              }}
            </p>

            <h4>{{ s__('ProjectSettings|Use Cases') }}</h4>
            <ul style="margin: 0 0 16px 0; padding-left: 20px; color: #666">
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Separate bugs from features with different workflows') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Apply different grading scales to different task types') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Organize tasks by work type for better tracking') }}
              </li>
              <li style="margin-bottom: 8px">
                {{ s__('ProjectSettings|Filter and report on tasks by category') }}
              </li>
            </ul>
          </div>
        </div>

        <div class="modal-footer">
          <button type="button" class="btn-primary" @click="handleClose">
            {{ s__('ProjectSettings|Close') }}
          </button>
        </div>
      </div>
    </div>
  </Teleport>
</template>

<script setup>
import { computed } from 'vue'
import { Teleport } from 'vue'
import { s__ } from '@/locale'
import CloseIcon from '../common/icons/CloseIcon.vue'
import { useBodyScrollLock } from '@/composables/useBodyScrollLock'

const props = defineProps({
  visible: {
    type: Boolean,
    required: true,
  },
})

const emit = defineEmits(['close'])

// Lock body scroll when modal is open
useBodyScrollLock(computed(() => props.visible))

function handleClose() {
  emit('close')
}
</script>

<style scoped>
.info-section {
  line-height: 1.6;
}

.info-section h4 {
  margin: 20px 0 8px 0;
  font-size: 16px;
  font-weight: 600;
  color: #333;
}

.info-section h4:first-child {
  margin-top: 0;
}

.info-section p {
  margin: 0 0 16px 0;
  color: #666;
}

.info-section ul {
  line-height: 1.6;
}
</style>
